import { render, staticRenderFns } from "./ClicksDataTable.vue?vue&type=template&id=5a3df850&scoped=true&"
import script from "./ClicksDataTable.vue?vue&type=script&lang=js&"
export * from "./ClicksDataTable.vue?vue&type=script&lang=js&"
import style0 from "./ClicksDataTable.vue?vue&type=style&index=0&id=5a3df850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3df850",
  null
  
)

export default component.exports